(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compact-product-bundle"] && !Shopify.designMode) return;
  try {
    
  // Keep the existing theme bundle action; do not duplicate its native selector.
  if (!customElements.get('modul-bundle-button-controller')) {
    class ModulBundleButtonController extends HTMLElement {
      connectedCallback() {
        this.bundle = this.closest('compact-product-bundle');
        if (!this.bundle) return;

        this.submitButton = this.bundle.querySelector('[data-product-bundle-submit]');
        if (!this.submitButton) return;

        this.ready = false;
        this.syncButtons = this.syncButtons.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.bundle.addEventListener('click', this.handleClick);

        // Mirror the native button's disabled/loading state on all card buttons.
        this.stateObserver = new MutationObserver(this.syncButtons);
        this.stateObserver.observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class']
        });

        // Variant changes can replace card contents with newly rendered HTML.
        this.cardObserver = new MutationObserver(this.syncButtons);
        const grid = this.bundle.querySelector('.product-grid');
        if (grid) this.cardObserver.observe(grid, { childList: true, subtree: true });
        this.syncButtons();

        customElements.whenDefined('compact-product-bundle').then(() => {
          if (!this.isConnected) return;
          this.ready = true;
          this.syncButtons();
        });
      }

      disconnectedCallback() {
        if (this.bundle && this.handleClick) {
          this.bundle.removeEventListener('click', this.handleClick);
        }
        if (this.stateObserver) this.stateObserver.disconnect();
        if (this.cardObserver) this.cardObserver.disconnect();
      }

      isBusy() {
        return this.submitButton.getAttribute('aria-busy') === 'true' ||
          this.submitButton.classList.contains('loading');
      }

      isBlocked() {
        return !this.ready || this.submitButton.disabled ||
          this.submitButton.getAttribute('aria-disabled') === 'true' || this.isBusy();
      }

      syncButtons() {
        if (!this.bundle || !this.submitButton) return;
        const disabled = this.isBlocked();
        const busy = this.isBusy() ? 'true' : 'false';
        this.bundle.querySelectorAll('[data-modul-bundle-proxy]').forEach((button) => {
          if (button.disabled !== disabled) button.disabled = disabled;
          if (button.getAttribute('aria-busy') !== busy) {
            button.setAttribute('aria-busy', busy);
          }
        });
      }

      handleClick(event) {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-modul-bundle-proxy]');
        if (!button || button.closest('compact-product-bundle') !== this.bundle) return;

        event.preventDefault();
        event.stopPropagation();
        if (this.isBlocked()) return;

        this.submitButton.click();
        this.syncButtons();
      }
    }

    customElements.define('modul-bundle-button-controller', ModulBundleButtonController);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modul-custom-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('modul-sticky-steps')) {
    customElements.define('modul-sticky-steps', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.ready) return;
        this.ready = true;
        this.steps = Array.from(this.querySelectorAll('[data-mss-step]'));
        this.panels = Array.from(this.querySelectorAll('[data-mss-panel]'));
        this.navLinks = Array.from(this.querySelectorAll('[data-mss-jump]'));
        this.visual = this.querySelector('[data-mss-visual]');
        this.frame = this.querySelector('[data-mss-frame]');
        if (!this.steps.length || !this.visual) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.mobile = window.matchMedia('(max-width: 989px)');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.reduceMotion.matches || this.dataset.autoplay !== 'true';
        this.playControl = this.querySelector('[data-mss-play]');
        this.active = -1;
        this.editorIndex = null;
        this.inView = false;
        this.timers = new Set();
        this.schedule = () => {
          if (this.frameRequest) return;
          this.frameRequest = requestAnimationFrame(() => {
            this.frameRequest = null;
            this.update();
          });
        };

        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        document.addEventListener('visibilitychange', () => this.syncVideo(), { signal });
        this.addEventListener('click', event => this.handleClick(event), { signal });
        this.addEventListener('change', event => this.handleVariant(event), { signal });
        this.addEventListener('submit', event => this.handleSubmit(event), { signal });
        this.reduceMotion.addEventListener('change', () => {
          this.userPaused = this.reduceMotion.matches || this.dataset.autoplay !== 'true';
          this.syncVideo();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.steps.findIndex(step => step.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.editorIndex = index;
          this.setActive(index);
          this.jumpTo(index, false);
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.steps.some(step => step.dataset.blockId === event.detail?.blockId)) return;
          this.editorIndex = null;
          this.schedule();
        }, { signal });

        this.querySelectorAll('[data-mss-products]').forEach(rail => {
          rail.addEventListener('scroll', () => this.updateRail(rail), { passive: true, signal });
        });
        this.querySelectorAll('video').forEach(video => {
          video.controls = false;
          video.muted = true;
          video.addEventListener('play', () => this.updatePlayControl(), { signal });
          video.addEventListener('pause', () => this.updatePlayControl(), { signal });
        });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.schedule);
          this.resizeObserver.observe(this.visual);
          this.steps.forEach(step => this.resizeObserver.observe(step));
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.syncVideo();
          }, { threshold: 0.01 });
          this.observer.observe(this.frame);
        } else {
          this.inView = true;
        }
        this.update();
      }

      update() {
        if (!this.visual || !this.isConnected) return;
        const visualHeight = Math.round(this.visual.getBoundingClientRect().height);
        if (this.visualHeight !== visualHeight) {
          this.visualHeight = visualHeight;
          this.style.setProperty('--mss-visual-height', `${visualHeight}px`);
        }
        const top = parseFloat(getComputedStyle(this).getPropertyValue('--mss-sticky-top')) || 0;
        const guide = this.mobile.matches
          ? top + visualHeight + Math.max(20, (window.innerHeight - top - visualHeight) * 0.22)
          : top + Math.max(80, (window.innerHeight - top) * 0.38);
        let index = 0;
        this.steps.forEach((step, i) => {
          if (step.getBoundingClientRect().top <= guide) index = i;
        });
        this.setActive(this.editorIndex === null ? index : this.editorIndex);
        this.querySelectorAll('[data-mss-products]').forEach(rail => this.updateRail(rail));
      }

      setActive(index) {
        if (this.active === index) return;
        this.active = index;
        this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        });
        this.navLinks.forEach((link, i) => {
          link.classList.toggle('is-active', i === index);
          if (i === index) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
        });
        this.syncVideo();
      }

      syncVideo() {
        const activeVideo = this.panels[this.active]?.querySelector('video');
        this.querySelectorAll('video').forEach(video => {
          const shouldPlay = video === activeVideo && this.inView && !this.userPaused && !document.hidden;
          if (shouldPlay && video.paused) {
            const attempt = video.play();
            if (attempt && typeof attempt.catch === 'function') {
              attempt.catch(() => this.updatePlayControl());
            }
          } else if (!shouldPlay && !video.paused) {
            video.pause();
          }
        });
        this.updatePlayControl();
      }

      updatePlayControl() {
        if (!this.playControl) return;
        const video = this.panels[this.active]?.querySelector('video');
        this.playControl.hidden = !video;
        if (!video) return;
        this.playControl.querySelector('[data-mss-play-label]').textContent = video.paused ? 'Play video' : 'Pause video';
      }

      jumpTo(index, smooth = true) {
        const step = this.steps[index];
        if (!step) return;
        const stickyTop = parseFloat(getComputedStyle(this).getPropertyValue('--mss-sticky-top')) || 0;
        const clearance = stickyTop + (this.mobile.matches ? this.visual.offsetHeight : 0) + 24;
        window.scrollTo({
          top: window.scrollY + step.getBoundingClientRect().top - clearance,
          behavior: smooth && !this.reduceMotion.matches ? 'smooth' : 'instant'
        });
      }

      handleClick(event) {
        const jump = event.target.closest('[data-mss-jump]');
        if (jump && this.contains(jump)) {
          event.preventDefault();
          const index = Number(jump.dataset.mssJump);
          this.editorIndex = null;
          this.jumpTo(index);
          this.steps[index]?.focus({ preventScroll: true });
          return;
        }
        if (event.target.closest('[data-mss-play]')) {
          const video = this.panels[this.active]?.querySelector('video');
          if (video) {
            this.userPaused = !video.paused;
            this.inView = true;
            this.syncVideo();
          }
          return;
        }
        const arrow = event.target.closest('[data-mss-direction]');
        if (arrow) {
          const rail = arrow.closest('[data-mss-step]')?.querySelector('[data-mss-products]');
          if (!rail) return;
          const rtl = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
          rail.scrollBy({
            left: rtl * Number(arrow.dataset.mssDirection) * rail.clientWidth * 0.85,
            behavior: this.reduceMotion.matches ? 'instant' : 'smooth'
          });
        }
      }

      updateRail(rail) {
        const arrows = rail.closest('[data-mss-step]')?.querySelector('[data-mss-arrows]');
        if (!arrows) return;
        const max = rail.scrollWidth - rail.clientWidth;
        arrows.hidden = max < 3;
        const left = Math.abs(rail.scrollLeft);
        arrows.querySelector('[data-mss-direction="-1"]').disabled = left < 3;
        arrows.querySelector('[data-mss-direction="1"]').disabled = left >= max - 3;
      }

      handleVariant(event) {
        const select = event.target.closest('[data-mss-variant]');
        if (!select || !select.value) return;
        const option = select.selectedOptions[0];
        const card = select.closest('[data-mss-product]');
        const price = card.querySelector('[data-mss-price]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        card.querySelectorAll('[data-mss-product-link]').forEach(link => {
          if (option.dataset.url) link.href = option.dataset.url;
        });
        const image = card.querySelector('.mss-card-image');
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
        }
        const status = card.querySelector('[data-mss-status]');
        if (status) { status.textContent = ''; status.classList.remove('is-error'); }
      }

      async handleSubmit(event) {
        const form = event.target.closest('[data-mss-form]');
        if (!form || !this.contains(form)) return;
        event.preventDefault();
        event.stopPropagation();
        if (this.cartBusy || !form.reportValidity()) return;
        const formData = new FormData(form);
        if (!formData.get('id')) return;
        const button = form.querySelector('[data-mss-add]');
        if (!button || button.disabled) return;
        const label = button.dataset.label;
        if (button.mssResetTimer) {
          clearTimeout(button.mssResetTimer);
          this.timers?.delete(button.mssResetTimer);
        }
        const status = form.querySelector('[data-mss-status]');
        const bagLink = form.querySelector('[data-mss-view-bag]');
        const controls = Array.from(this.querySelectorAll('[data-mss-add], [data-mss-variant]'));
        const disabledStates = controls.map(control => control.disabled);
        this.cartBusy = true;
        controls.forEach(control => { control.disabled = true; });
        form.setAttribute('aria-busy', 'true');
        button.textContent = this.dataset.addingLabel || 'Adding…';
        status.textContent = '';
        status.classList.remove('is-error');
        bagLink.hidden = true;
        const request = new AbortController();
        const timeout = setTimeout(() => request.abort(), 25000);
        let added = false;
        try {
          // routes.cart_add_url preserves the visitor's locale.
          const endpoint = new URL(form.action);
          endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
          const response = await fetch(endpoint.toString(), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body: formData,
            signal: request.signal
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            const description = result.description || result.message;
            throw new Error(typeof description === 'string' ? description : this.dataset.errorLabel);
          }
          added = true;
          status.textContent = this.dataset.addedLabel || 'Added to your bag.';
          button.textContent = this.dataset.addedLabel || 'Added to your bag.';
          bagLink.hidden = false;
          // Official Concept event: refreshes the theme's cart and optionally opens it.
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: this.dataset.openCart === 'true' }
          }));
        } catch (error) {
          if (!added) {
            const message = error.name === 'AbortError' || error instanceof TypeError || error instanceof SyntaxError
              ? (this.dataset.errorLabel || 'Could not confirm. Check your bag before retrying.')
              : error.message;
            status.textContent = message || this.dataset.errorLabel;
            status.classList.add('is-error');
            bagLink.hidden = false;
          }
        } finally {
          clearTimeout(timeout);
          this.cartBusy = false;
          form.removeAttribute('aria-busy');
          controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
          if (added) {
            const timer = setTimeout(() => {
              if (button.isConnected) button.textContent = label;
              this.timers?.delete(timer);
              button.mssResetTimer = null;
            }, 2500);
            button.mssResetTimer = timer;
            this.timers?.add(timer);
          } else {
            button.textContent = label;
          }
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.frameRequest);
        this.frameRequest = null;
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.observer?.disconnect();
        this.timers?.forEach(timer => clearTimeout(timer));
        this.querySelectorAll('video').forEach(video => video.pause());
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modul-launch-faq"] && !Shopify.designMode) return;
  try {
    

(() => {

  'use strict';

  if (customElements.get('modul-launch')) return;



  // Pinned module keeps its symbols private and avoids colliding with another app's phone widget.

  const ITI_BASE = 'https://cdn.jsdelivr.net/npm/intl-tel-input@29.5.3/dist';

  const REVISION = '2026-07-15';

  let phoneLibraryPromise;



  function loadPhoneLibrary() {

    if (phoneLibraryPromise) return phoneLibraryPromise;

    phoneLibraryPromise = (async () => {

      const cssReady = new Promise((resolve, reject) => {

        let link = document.querySelector('link[data-modul-iti="29.5.3"]');

        if (link && link.sheet) { resolve(); return; }

        if (!link) {

          link = document.createElement('link');

          link.rel = 'stylesheet';

          link.href = `${ITI_BASE}/css/intlTelInput.css`;

          link.dataset.modulIti = '29.5.3';

          document.head.appendChild(link);

        }

        const timeout = setTimeout(() => reject(new Error('Phone styles timed out.')), 15000);

        link.addEventListener('load', () => { clearTimeout(timeout); resolve(); }, { once: true });

        link.addEventListener('error', () => { clearTimeout(timeout); reject(new Error('Phone styles unavailable.')); }, { once: true });

      });

      const [module] = await Promise.all([

        import(`${ITI_BASE}/js/intlTelInputWithUtils.mjs`), cssReady

      ]);

      if (typeof module.default !== 'function') throw new Error('Phone library unavailable.');

      return module.default;

    })();

    return phoneLibraryPromise;

  }



  function publicIdIsValid(value) {

    // Public site/list IDs are short alphanumeric strings. Refuse accidental private keys.

    return /^[a-zA-Z0-9]{4,16}$/.test(value || '') && !/^pk_/i.test(value || '');

  }



  class ModulLaunch extends HTMLElement {

    connectedCallback() {

      this._frame = requestAnimationFrame(() => this.init());

    }



    disconnectedCallback() {

      cancelAnimationFrame(this._frame);

      this._events?.abort();

      this._request?.abort();

      this._resize?.disconnect();

      this.iti?.destroy();

      this.iti = null;

      this._initialized = false;

      this._inFlight = false;

    }



    init() {

      if (this._initialized || !this.isConnected) return;

      this._initialized = true;

      this._events = new AbortController();

      const { signal } = this._events;



      // Break out of a padded theme container using the viewport *excluding* its scrollbar.

      const sizeCanvas = () => {

        if (this.dataset.fullBleed === 'true') {

          this.style.setProperty('--ml-bleed-width', `${document.documentElement.clientWidth}px`);

        } else this.style.removeProperty('--ml-bleed-width');

      };

      sizeCanvas();

      window.addEventListener('resize', sizeCanvas, { signal, passive: true });

      if ('ResizeObserver' in window) {

        this._resize = new ResizeObserver(sizeCanvas);

        this._resize.observe(document.documentElement);

      }



      this.querySelectorAll('[data-ml-faq]').forEach((details) => {

        details.addEventListener('toggle', () => {

          if (!details.open || this.dataset.singleFaq !== 'true') return;

          this.querySelectorAll('[data-ml-faq]').forEach((other) => {

            if (other !== details) other.open = false;

          });

        }, { signal });

      });

      document.addEventListener('shopify:block:select', (event) => {

        const block = Array.from(this.querySelectorAll('[data-ml-faq]'))

          .find((item) => item.dataset.blockId === event.detail?.blockId);

        if (block) block.open = true;

      }, { signal });



      if (this.dataset.provider !== 'klaviyo') return;

      this.form = this.querySelector('[data-ml-form]');

      if (!this.form) return;

      this.fields = this.querySelector('[data-ml-fields]');

      this.email = this.querySelector('[data-ml-email]');

      this.phone = this.querySelector('[data-ml-phone]');

      this.submitButton = this.querySelector('[data-ml-submit]');

      this.status = this.querySelector('[data-ml-status]');

      this.sms = this.querySelector('[data-ml-sms]');

      this.smsCountries = (this.dataset.smsCountries || '').split(',').map((s) => s.trim()).filter(Boolean);

      this._smsConfigured = this.dataset.smsEnabled === 'true' && !!this.dataset.smsTerms &&

        !!this.dataset.privacyUrl && this.smsCountries.length > 0 &&

        !!this.querySelector('[data-ml-sms-disclosure]')?.textContent.trim();

      this._phoneReady = false;

      this._phoneFailed = false;

      this._inFlight = false;

      this._submitted = false;



      // Prevent a normal browser post *before* enabling any input controls.

      this.form.addEventListener('submit', (event) => {

        event.preventDefault();

        this.handleSubmit();

      }, { signal });

      this.email.addEventListener('input', () => {

        this.email.removeAttribute('aria-invalid');

      }, { signal });

      this.phone.addEventListener('input', () => {

        this.setPhoneError('');

        this.updateSmsAvailability();

      }, { signal });

      this.phone.addEventListener('countrychange', () => {

        this.setPhoneError('');

        this.updateSmsAvailability();

      }, { signal });



      const configured = publicIdIsValid(this.dataset.company) && publicIdIsValid(this.dataset.list) &&

        (!this.dataset.smsList || publicIdIsValid(this.dataset.smsList));

      if (configured) {

        this.fields.disabled = false;

      } else {

        this.fields.disabled = true;

        this.showStatus(window.Shopify?.designMode

          ? 'Add your Klaviyo PUBLIC Site ID and email list ID in this section’s settings. Do not enter a private API key.'

          : 'Signup is temporarily unavailable. Please check back soon.', 'error', false);

      }

      this.updateSmsAvailability();

      // Load in the editor too, so the country selector can be previewed before keys are set.

      this.initPhone(signal);

    }



    async initPhone(signal) {

      try {

        const intlTelInput = await loadPhoneLibrary();

        if (signal.aborted || !this.isConnected) return;

        const preferred = (this.dataset.defaultCountry || '').toLowerCase();

        const known = intlTelInput.getAllCountries();

        const initialCountry = known.some((country) => country.iso2 === preferred) ? preferred : '';

        this.iti = intlTelInput(this.phone, {

          initialCountry,

          separateDialCode: true,

          numberDisplayFormat: 'INTERNATIONAL',

          countrySearch: true,

          countrySelectorMode: 'DROPDOWN',

          formatAsYouType: true,

          strictMode: false,

          allowedNumberTypes: ['MOBILE', 'FIXED_LINE'],

          placeholderNumberPolicy: 'AGGRESSIVE',

          customPlaceholder: (example) => example || 'Phone number (optional)'

        });

        await this.iti.promise;

        if (signal.aborted || !this.isConnected) return;

        this._phoneReady = true;

        // The parent fieldset may still be disabled when integration IDs are missing.

        this.updateSmsAvailability();

      } catch (_error) {

        if (signal.aborted || !this.isConnected) return;

        this._phoneFailed = true;

        const help = this.querySelector('[data-ml-phone-help]');

        help.textContent = 'The phone selector could not load. Refresh to add a phone number, or leave this optional field empty to join by email.';

        this.updateSmsAvailability();

      }

    }



    updateSmsAvailability() {

      if (!this.sms) return;

      const region = this.iti?.getSelectedCountry()?.iso2 || '';

      const allowed = this._smsConfigured && this._phoneReady && this.smsCountries.includes(region);

      this.sms.disabled = !allowed;

      if (!allowed) this.sms.checked = false;

      const note = this.querySelector('[data-ml-sms-region]');

      let message = '';

      if (!this._smsConfigured) message = 'Text signup is not available yet. You can still join by email.';

      else if (!this._phoneReady) message = 'Choose a phone country to check text-update availability.';

      else if (!region) message = 'Choose a phone country to check text-update availability.';

      else if (!allowed) message = 'Text updates are not offered for this country. You can still join by email.';

      note.textContent = message;

      note.hidden = !message;

    }



    setPhoneError(message) {

      const node = this.querySelector('[data-ml-phone-error]');

      if (!node) return;

      node.textContent = message;

      node.hidden = !message;

      if (message) this.phone.setAttribute('aria-invalid', 'true');

      else this.phone.removeAttribute('aria-invalid');

    }



    showStatus(message, kind = 'info', focus = true) {

      this.status.textContent = message;

      this.status.className = `mlaunch__status mlaunch__status--${kind}`;

      this.status.hidden = false;

      this.status.setAttribute('role', kind === 'error' ? 'alert' : 'status');

      if (focus) this.status.focus({ preventScroll: true });

    }



    validatePhone() {

      const raw = this.phone.value.trim();

      if (!raw) {

        if (this.sms?.checked) {

          this.setPhoneError('Enter your phone number to sign up for text updates.');

          this.phone.focus();

          return null;

        }

        return '';

      }

      if (!this._phoneReady) {

        this.setPhoneError(this._phoneFailed

          ? 'Phone validation is unavailable. Refresh, or leave the phone field empty to sign up by email.'

          : 'The phone selector is still loading. Please try again in a moment.');

        this.phone.focus();

        return null;

      }

      if (!this.iti.getSelectedCountry()) {

        this.setPhoneError('Choose your country or enter the full number starting with +.');

        this.phone.focus();

        return null;

      }

      if (this.iti.getExtension()) {

        this.setPhoneError('Please use a phone number without an extension.');

        this.phone.focus();

        return null;

      }

      if (!this.iti.isValidNumber()) {

        this.setPhoneError('Check the phone number and selected country, or leave this optional field empty.');

        this.phone.focus();

        return null;

      }

      const number = this.iti.getNumber();

      if (!/^\+[1-9]\d{1,14}$/.test(number)) {

        this.setPhoneError('Please enter a valid international phone number.');

        this.phone.focus();

        return null;

      }

      return number;

    }



    makePayload(attributes, list) {

      return {

        data: {

          type: 'subscription',

          attributes: {

            custom_source: 'Modul launch section',

            profile: { data: { type: 'profile', attributes } }

          },

          relationships: { list: { data: { type: 'list', id: list } } }

        }

      };

    }



    async postSubscription(payload) {

      this._request = new AbortController();

      const timeout = setTimeout(() => this._request?.abort(), 20000);

      try {

        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(this.dataset.company)}`, {

          method: 'POST', mode: 'cors', credentials: 'omit',

          headers: {

            accept: 'application/vnd.api+json',

            'content-type': 'application/vnd.api+json',

            revision: REVISION

          },

          body: JSON.stringify(payload),

          signal: this._request.signal

        });

        if (response.status !== 202) {

          const error = new Error(response.status === 429

            ? 'Too many attempts. Please wait a minute and try again.'

            : 'The signup service could not accept this request. Check your details and try again.');

          error.httpStatus = response.status;

          throw error;

        }

        // Some API responses can accept the email but reject the phone. Do not call this full success.

        // This header can only be inspected when the provider exposes it to browser CORS requests.

        return response.headers.get('X-Klaviyo-Partial-Failure') || '';

      } finally {

        clearTimeout(timeout);

        this._request = null;

      }

    }



    async handleSubmit() {

      if (this._inFlight || this._submitted || this.fields.disabled) return;

      if (!this.form.reportValidity()) return;

      if (this.querySelector('[data-ml-trap]').value.trim()) {

        this.showStatus('Unable to submit this form. Please refresh and try again.', 'error');

        return;

      }

      this.setPhoneError('');

      const number = this.validatePhone();

      if (number === null) return;

      const wantsSms = !!(this.sms?.checked && !this.sms.disabled && number);

      const separateSmsList = wantsSms && this.dataset.smsList && this.dataset.smsList !== this.dataset.list;

      const attributes = {

        email: this.email.value.trim(),

        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },

        properties: { 'Modul signup source': 'Launch section' }

      };

      if (number) attributes.phone_number = number;

      if (wantsSms && !separateSmsList) attributes.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };

      if (wantsSms) {

        attributes.properties['Modul SMS disclosure'] = this.querySelector('[data-ml-sms-disclosure]').textContent.trim();

      }

      // Never infer SMS consent from a nonempty phone field. Explicit channels are always sent.

      this._inFlight = true;

      this.form.setAttribute('aria-busy', 'true');

      this.fields.disabled = true;

      this.status.hidden = true;

      let emailAccepted = false;

      try {

        const partial = await this.postSubscription(this.makePayload(attributes, this.dataset.list));

        if (!this.isConnected) return;

        emailAccepted = true;

        if (partial) {

          this.showStatus('Your email signup request was accepted, but the phone portion was not. Check your number and try again, or clear the optional phone field.', 'error');

          return;

        }

        if (separateSmsList) {

          const smsAttributes = {

            phone_number: number,

            subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } },

            properties: { 'Modul SMS disclosure': this.querySelector('[data-ml-sms-disclosure]').textContent.trim() }

          };

          // Phone-only SMS request avoids silently treating a rejected phone as an email-only success.

          const smsPartial = await this.postSubscription(this.makePayload(smsAttributes, this.dataset.smsList));

          if (!this.isConnected) return;

          if (smsPartial) throw new Error('Text signup could not be accepted.');

        }

        this._submitted = true;

        this.showStatus(this.dataset.success || 'Thanks! Check your inbox for any confirmation needed to finish signing up.', 'success');

      } catch (error) {

        if (!this.isConnected) return;

        let message;

        if (emailAccepted) message = 'Your email signup request was accepted, but text signup could not be completed. Check the phone number and try again, or leave text updates unchecked.';

        else if (error.name === 'AbortError') message = 'The request timed out. Check for a confirmation before trying again.';

        else if (error instanceof TypeError) message = 'Could not reach the signup service. Check your connection and try again.';

        else message = error.message || 'Signup could not be completed. Please try again.';

        this.showStatus(message, 'error');

      } finally {

        this._inFlight = false;

        if (this.isConnected) {

          this.form.removeAttribute('aria-busy');

          this.fields.disabled = this._submitted;

          this.updateSmsAvailability();

        }

      }

    }

  }



  customElements.define('modul-launch', ModulLaunch);

})();




  } catch(e) { console.error(e); }
})();
})();
